export default __webpack_public_path__ + "static/media/DT-bluebackground.acef7799.svg";